import common from './old/public/common';
import config from '../config/config';
import Vue from 'vue';
import store from './old/store/store'
import network from './network'
import {
  // getOprPkId,
  getTokenTime
} from './api';

const init = {
  isInit: false,
  async init(next, to) {

    this.isInit = true;
    let oprPkId = common.query('oprPkId') || ''; //运营商Id
    let localOprPkId = common.get('oprPkId') || ''; //本地保存运营商Id
    let token = common.get('token') || ''; //本地保存的登录token
    let userInfo = common.get('userInfo') || {}; //本地保存的登录信息
    let orgCode = common.query('orgCode') || ''; //二维码参数信息
    let gid = common.query('gid') || ''; //二维码参数信息
    let inviter = common.query('inviter') || ''; //邀请人信息
    if(inviter && inviter != ''){
      common.save('inviter', inviter); //保存二维码信息
    }
    if (!common.isEmpty(orgCode) && !common.isEmpty(gid)) {
      //保存二维码信息
      common.save(config.localKeyLogin.qr, {
        operatorId: orgCode,
        gunPkId: gid,
        customInfo: ''
      }); //保存二维码信息
    }
    //如果是入口界面
    if (to.name === 'login') {
      //如果是扫码进来的先请求运营商的Id
      
      // if (!common.isEmpty(qr)) {
      //   common.save(config.localKeyLogin.qr, qr); //保存二维码信息
      //   let serialNo = qr.split('_')[0];
      //   let ret = await getOprPkId({
      //     serialNo: serialNo,
      //     appType: 1
      //   });
      //   console.log(ret);
      //   if (ret.status === config.ajaxStatus && ret.data[0]) {
      //     oprPkId = ret.data[0].oprPkId;
      //   } else {
      //     //查不到运营商
      //     Vue.prototype.$dialog.alert({
      //       title: '此桩没有查到运营商，请联系管理员',
      //       confirmButtonText: '确认',
      //       confirmButtonColor: '#14CC80'
      //     }).then(() => {
      //       this.close();
      //     });
      //     return;
      //   }
      // } else 
      
      if (common.isEmpty(oprPkId)) {
        //没有运营商Id
        Vue.prototype.$dialog.alert({
          title: '没有查到运营商',
          confirmButtonText: '确认',
          confirmButtonColor: '#14CC80'
        }).then(() => {
          this.close();
        });
        return;
      } else {
        Vue.prototype.$oprPkId = oprPkId;
      }
    } else {
      // 不是登录界面
    }

    if (token) {
      // 已经登录过，但是本地运营商跟参数不一致需要重新登录
      if (oprPkId && oprPkId != localOprPkId) {
        this.clearLocalData();
        this.toLogin(next, oprPkId);
      } else {
        if (to.name === 'login') {
          //如果token存在则检查token是否还有效
          let ret = await getTokenTime({
            token: token
          });
          if (ret.status === config.ajaxStatus && ret.data[0]) {
            if (ret.data[0] === -1 || ret.data[0] > 5) {
              //token有效，直接跳转到首页

              store.commit('SET_USERINFO', userInfo);
              common.remove('accountPkId');
              next('home2');
            } else {
              //token过期，调到登录界面
              common.remove('token');
              this.toLogin(next, oprPkId);
            }
          } else {
            //请求失败，调到登录界面
            console.log('request token expire fail');
            this.toLogin(next, oprPkId);
          }

        } else {
          store.commit('SET_USERINFO', userInfo);
          Vue.prototype.$oprPkId = localOprPkId;
          next();
        }
      }
    }
    //  else if (!common.isEmpty(qr) && to.name === 'login') {
    //   //如果没有token，在login界面，并且有qr参数，说明是扫码进来的，跳转到login界面把oprPkId参数加上去
    //   this.toLogin(next, oprPkId);
    // } 
    else {
      next();
    }
    network();
  },
  clearLocalData() {
    common.remove('token');
    common.remove('oprPkId');
    common.remove('phone');
    common.remove('accountPkId');
    common.remove('userInfo');
  },
  toLogin(next, oprPkId) {
    next({
      name: 'login',
      query: {
        oprPkId: oprPkId
      }
    });
  },
  close() {
    console.log('close');
    //关闭页面
  }
};
export default init;